var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvanceNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-961 21721)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 961, -21721)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 15,
    transform: "translate(3 2)",
    fill: "#ddd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(972.685 -21710.344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.734,21.293V19.619a9.1,9.1,0,0,0-2-17.98,9.146,9.146,0,0,0-9.094,9.1,9.037,9.037,0,0,0,1.841,5.492H1.514A10.731,10.731,0,1,1,12.736,21.29Z",
    transform: "translate(5.554 0)",
    fill: "#80808c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.742 4.31)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.512,69.148h-1.241a3.887,3.887,0,0,0-.537-1.3h1.778a.926.926,0,0,0,0-1.852h-7.24a.926.926,0,0,0,0,1.852h2.074a2.213,2.213,0,0,1,1.972,1.3h-4.046a.926.926,0,0,0,0,1.852h4.046a2.944,2.944,0,0,1-.426.583,2.161,2.161,0,0,1-1.546.62h-2.074a.932.932,0,0,0-.926.944.956.956,0,0,0,.287.667l5.175,4.9a.923.923,0,1,0,1.268-1.342l-3.49-3.305a3.99,3.99,0,0,0,2.6-1.157A4.144,4.144,0,0,0,285.271,71h1.241a.926.926,0,0,0,0-1.852Z",
    transform: "translate(-278.346 -66)",
    fill: "#80808c"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16.674,7.935,10.712,2.149a.526.526,0,0,0-.892.377V5.509A10.007,10.007,0,0,0,0,15.5a.518.518,0,0,0,.4.5.5.5,0,0,0,.124.015A.553.553,0,0,0,1,15.731a8.946,8.946,0,0,1,7.824-4.612H9.82V14.1a.526.526,0,0,0,.892.377L16.674,8.69a.525.525,0,0,0,0-.755Z",
    transform: "translate(0 11.069)",
    fill: "#80808c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceNew);
export default __webpack_public_path__ + "static/media/Advance_New.caf26b5dd9a365150756efbefc6ee0b4.svg";
export { ForwardRef as ReactComponent };